export const DEFAULT_STARTING_VOLTAGE = 80;
export const DEFAULT_STARTING_VOLTAGE_FOR_YD = 100;
export const DEFAULT_STARTING_VOLTAGE_FOR_CUSTOM = 100;
